<template>
  <div>
    <div class="enter">
      <div class="right">
        <!-- 图片 -->
        <img
          style="height: 320px; width: 100%"
          src="../../assets/contact.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />

    <div class="product contentCss">
      <div class="introduction">
        <h3 class="gsjj">公司简介</h3>
        <!-- 排版左图右字 -->
        <div class="hoverImage">
          <HoverImage
            style="width: 85%"
            :imageSrc="lianxiwomen"
            imageAlt="信电查"
          ></HoverImage>
        </div>
        <div class="presentation needLeft">
          <div class="text">
            <p>
              <span style="font-size: 50px; text-align: center; color: #28baf9"
                >.</span
              >
              中电联（北京）征信有限公司成立于2015年10月22日，公司注册资金5000万元，前身为中电联（北京）信用评价有限公司，负责开展行业信用评价工作。2018年5月4日正式更名为中电联（北京）征信有限公司，探索开展市场化电力征信服务。
            </p>
          </div>
          <div class="text">
            <p>
              <span style="font-size: 50px; text-align: center; color: #28baf9"
                >.</span
              >
              通过融通电力行业对涉电力领域市场主体的征信记录数据，为行业高质量发展提供征信大数据支撑；
              整合“用信”头部企业的资金、人才和市场等资源，深度融合“用信”场景，精准提供征信服务，打造“电力征信”品牌；
              兑现中电联征信公司向人民银行的承诺，成为专业化市场化行业征信机构的示范。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 公司发展历程，时间线 -->
    <h3 class="gsjj contentCss">公司大事件</h3>
    <div
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      class="h-100 p-r"
    >
      <div class="timelineBox">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in versionAnnouncementList"
            :key="index"
            :color="item.color"
            style="font-size: 16px"
          >
            <div v-if="index % 2 == 0" class="evenDiv">
              <div class="timelinItemBox0">
                <div
                  class="timelinItemBox-top f-r a-c"
                  style="background-color: #507cbe"
                >
                  <div class="leftCss">{{ item.releaseTime }}</div>
                </div>
                <div class="timelinItemBox-bottom">
                  <span>{{ item.content }}</span>
                </div>
              </div>
              <div class="timelinItemBox1">
                <div class="timelinItemBox-top f-r a-c">
                  <div class="leftCss">{{ item.releaseTime }}</div>
                </div>
                <div class="timelinItemBox-bottom">
                  {{ item.content }}
                </div>
              </div>
            </div>

            <div v-else class="unevenDiv">
              <div class="timelinItemBox0">
                <div class="timelinItemBox-top f-r a-c">
                  <div class="rightCss">{{ item.releaseTime }}</div>
                </div>
                <div class="timelinItemBox-bottom">
                  {{ item.content }}
                </div>
              </div>
              <div class="timelinItemBox1">
                <div
                  class="timelinItemBox-top f-r a-c"
                  style="background-color: #507cbe"
                >
                  <div class="rightCss" style="text-align: right">
                    {{ item.releaseTime }}
                  </div>
                </div>
                <div class="timelinItemBox-bottom">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <div class="map contentCss">
      <div class="dizhi">
        <p>地址 : 北京市丰台区槐房西路9号院7号楼</p>
        <p>电话 : 010-83935995/83935996</p>
        <p>邮箱 : creditinvestigation@cec.org.cn</p>
        <div style="text-align: center">
          <img src="../../assets/zdl_qr.jpg" alt="" />
        </div>
      </div>
      <div style="margin-top: 20px;width: 68%;height: 400px;border: none;;">
        <img src="../../assets/baiduAddress.jpg" alt="">
      </div>
      <!-- <iframe
        style="margin-top: 20px"
        width="68%"
        height="400"
        frameborder="0"
        src="./baidu.html"
      ></iframe> -->
    </div>
  </div>
</template>

<script>
import zdlFirst from '@/assets/zdl_first.png'
import HoverImage from '@/components/HoverImage'
import dlzxBgc2 from '@/assets/dlzxBgc2.png'
import dlzxBgc3 from '@/assets/dlzxBgc3.png'
import lianxiwomen from '@/assets/lianxiwomen.jpg'

// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'contact-name',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      zdlFirst,
      dlzxBgc2,
      dlzxBgc3,
      daohangshuju: '联系我们',
      lianxiwomen,
      versionAnnouncementList: [
        {
          uuid: '20230314_1053_5398371131177979',
          content: '计算机软件著作权登记证书（中电联电力征信公共信用综合评价系统（升级版）V2.0）',
          version: 'V3.1',
          releaseTime: '2023年5月30日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        },
        {
          uuid: '20230314_1053_5398371131177979',
          content: '“电力征信”平台信息系统安全等级保护二级测评',
          version: 'V3.1',
          releaseTime: '2021年9月13日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507CBE'
        },
        {
          uuid: '20230314_1053_5398371131177979',
          content: '管理体系认证',
          version: 'V3.1',
          releaseTime: '2021年9月16日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        },
        {
          uuid: '20230314_1053_5398371131177979',
          content: '“京津冀”征信链9家征信机构之一',
          version: 'V3.1',
          releaseTime: '2021年7月',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507CBE'
        },
        {
          uuid: '20230314_1053_5398371131177979',
          content: '增值电信业务许可证（信息服务业务（仅限互联网信息服务））',
          version: 'V3.1',
          releaseTime: '2021年5月13日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        },
        {
          uuid: '20230314_1053_5398371131177980',
          content: '计算机软件著作权登记证书（中电联电力征信公共信用综合评价系统V1.0）',
          version: 'V3.1',
          releaseTime: '2020年11月3日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        },
        {
          uuid: '20230314_1053_5398371131177980',
          content: '可为信用修复申请人出具信用报告的信用服务机构（第一批）',
          version: 'V3.1',
          releaseTime: '2019年11月10日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        },
        {
          uuid: '20230314_1053_5398371131177980',
          content: '企业征信机构备案',
          version: 'V3.1',
          releaseTime: '2019年4月17日',
          createTime: '2023-03-14 10:53:49',
          updateTime: '2023-03-14 15:01:13',
          color: '#507cbe'
        }
      ]
    }
  }

}
</script>

<style lang="less" scoped>
.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}

.hoverImage {
  width: 42%;
  display: inline-block;
  vertical-align: middle;
}

.daohang {
  padding-bottom: 10px;
  font-size: 20px;
  color: #00489d;
  border-bottom: 1px solid #005ba3;
}
.gsjj {
  text-align: center;
  color: #00489d;
  font-size: 30px;
  margin-bottom: 50px;
}
.product {
  .introduction {
    line-height: 30px;
    width: 100%;
    display: inline-block;
    vertical-align: middle;

    .presentation {
      text-align: left;
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      h3 {
        color: #00489d;
        font-size: 18px;
      }

      .text {
        .tuchu {
          font-size: 16px;
          font-weight: 700;
        }
      }
    }
  }
}

.map {
  margin-top: 820px;
  display: flex;
  margin-bottom: 50px;
  .dizhi {
    width: 37%;
    padding: 20px;
    background: #f5f5f5;
    margin-top: 20px;
    text-align: left;
    p {
      line-height: 35px;
    }
    img {
      width: 190px;
      height: 190px;
      margin-top: 20px;
    }
  }
}

.h-100 {
  height: 100%;
}
.p-r {
  position: relative;
}
.f-r {
  display: flex;
  flex-direction: row;
}
.a-c {
  align-content: center;
  align-items: center;
}
.m-l20 {
  margin-left: 20px;
}
// 通用样式 end

.timelineBox {
  position: absolute;
  left: 50%;
  top: 2%;
  width: 620px;
  .el-timeline-item {
    padding-bottom: 5px;
  }
}
.timelinItemBox0 {
  width: 600px;
  height: calc(100% - 2px);
  position: absolute;
  right: calc(100% + 18px);
  border: 1px solid #dedede;
  border-radius: 5px;
}
.timelinItemBox1 {
  height: calc(100% - 2px);
  border: 1px solid #dedede;
  border-radius: 5px;
}
.timelinItemBox-top {
  height: 35px;
  padding: 0 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #ffffff;
}
.timelinItemBox-bottom {
  padding: 10px;
  color: #606266;
  line-height: 20px;
  white-space: pre-wrap;
}
.evenDiv {
  .timelinItemBox1 {
    border: 1px solid #ffffff;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    .timelinItemBox-bottom {
      color: #ffffff;
    }
  }
}
.unevenDiv {
  .timelinItemBox0 {
    border: 1px solid #ffffff;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    .timelinItemBox-bottom {
      color: #ffffff;
    }
  }
}

.leftCss {
  // text-align: center;
  // margin-left: 400px;
  margin-left: 420px;
}
</style>
